import { Popover, Typography } from 'antd'

import { parseResponse } from '../Helpers/exchangePayload'

interface ResponseCellProps {
    raw: string | null | undefined
    isError: boolean
}

const PREVIEW_LENGTH = 60

/** Комірка «Відповідь»: короткий текст, повний — у Popover по кліку; помилки червоним */
export const ResponseCell = ({ raw, isError }: ResponseCellProps) => {
    const text = parseResponse(raw)
    if (!text) return <Typography.Text type="secondary">—</Typography.Text>

    const preview = text.length > PREVIEW_LENGTH ? `${text.slice(0, PREVIEW_LENGTH)}…` : text

    return (
        <Popover
            trigger="click"
            title="Відповідь"
            content={<div style={{ maxWidth: 420, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</div>}
        >
            <Typography.Text
                {...(isError ? { type: 'danger' as const } : {})}
                style={{ cursor: 'pointer', textDecoration: 'underline dotted' }}
                onClick={(event) => event.stopPropagation()}
            >
                {preview}
            </Typography.Text>
        </Popover>
    )
}
